import { hnoFormatter, translateToLocalDate } from "utils/helpers";

export type Msag = {
  id?: number | undefined;
  PrefixDir?: string | undefined;
  StreetName?: string | undefined;
  StreetSuffix?: string | undefined;
  PostDir?: string | undefined;
  HNP?: string | undefined;
  LowRange?: string | undefined;
  HiRange?: string | undefined;
  HNE?: string | undefined;
  MCN?: string | undefined;
  State?: string | undefined;
  Side?: 1 | 2 | 3 | undefined;
  esn?: string | undefined;
  ExtractDate?: string | undefined;
  psapID?: string | undefined;
  CountyID?: string | undefined;
  Exchange?: string | undefined;
  GeneralUse?: string | undefined;
  TAR?: string | undefined;
  Reserved?: string | undefined;
  ExpandExtDate?: string | undefined;
  created?: string | undefined;
  created_by?: string | undefined;
  last_modified?: string | undefined;
  modified_by?: string | undefined;
};

export const remove = (cell, formatterParams, onRendered) => {
  return `<calcite-icon id="trashIcon" icon="trash" scale="s"></calcite-icon>`;
};

export const options = (cell, formatterParams, onRendered) => {
  let id = cell.getData().id;
  let hasEditPermission = formatterParams?.hasEditPermission;
  let hasAliViewPermission = formatterParams?.hasAliViewPermission;
  let opts = "";
  if (hasEditPermission) {
    opts += `<a href="/msag-records/${id}"><calcite-icon id="editRecord-${id}" icon="pencil" scale="s" style="margin-right:8px;" title="Edit MSAG Record"></calcite-icon></a>
            <calcite-icon id="deleteRecord-${id}" icon="trash" scale="s" style="margin-right:8px;" title="Delete MSAG Record"></calcite-icon>`;
  } else {
    opts += `<a href="/msag-records/view/${id}"><calcite-icon id="viewRecord-${id}" icon="view-visible" scale="s" style="margin-right:8px;" title="View MSAG Record"></calcite-icon></a>`;
  }

  if (hasAliViewPermission) {
    opts += `<a href="#" title="View ALI Records" onclick="localStorage.removeItem('aliRecords-criteria'); localStorage.setItem('aliRecords-criteria', JSON.stringify([{field: 'msag_id', type: '=', value: '${id}'}])); window.location.href='/ali-records'; return false;"><calcite-icon icon="pin-tear" scale="s"></calcite-icon></a>`;
  }

  return opts;
};

export function getMSAGExportColumns() {
  return {
    "MSAG ID": "id",
    "Prefix Directional": "PrefixDir",
    "Street Name": "StreetName",
    "Street Suffix": "StreetSuffix",
    "Post Directional": "PostDir",
    "MSAG Community Name": "MCN",
    "Low Range": "LowRange",
    "High Range": "HiRange",
    Side: "Side",
    "General Use": "GeneralUse",
    State: "State",
    "Emergency Service Number": "esn",
    "County ID": "CountyID",
    "Last Modified": "last_modified",
  };
}

export function getMsagColumns(
  hasEditPermission: boolean,
  hasAliViewPermission: boolean,
) {
  let msagColumns: ColumnDefinition[] = [
    {
      title: "",
      field: "actions",
      formatter: options,
      formatterParams: {
        hasEditPermission,
        hasAliViewPermission,
      },
      width: 75,
      minWidth: 50,
      hozAlign: "center",
      headerSort: false,
      headerFilter: false,
    },
    {
      title: "ID",
      field: "id",
      headerSort: true,
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 100,
      // minWidth: 50,
      formatter: "number",
    },
    {
      title: "Street Name",
      field: "StreetName",
      headerSort: true,
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 150,
      // minWidth: 50,
    },
    {
      title: "Prefix Directional",
      field: "PrefixDir",
      headerSort: true,
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 150,
      // minWidth: 50,
    },
    {
      title: "Street Suffix",
      field: "StreetSuffix",
      headerSort: true,
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 150,
      // minWidth: 50,
    },
    {
      title: "Post Directional",
      field: "PostDir",
      headerSort: true,
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 150,
      // minWidth: 50,
    },
    {
      title: "MCN",
      field: "MCN",
      headerSort: true,
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 150,
      // minWidth: 50,
    },
    {
      title: "Low Range",
      field: "LowRange",
      formatter: hnoFormatter,
      headerSort: true,
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 150,
      // minWidth: 50,
    },
    {
      title: "High Range",
      field: "HiRange",
      formatter: hnoFormatter,
      headerSort: true,
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 150,
      // minWidth: 50,
    },
    {
      title: "Side",
      field: "Side",
      // headerSort: true,
      // sorter: "string",
      formatter: "lookup",
      // headerFilterLiveFilter: false,
      formatterParams: {
        1: "O",
        2: "E",
        3: "B",
      },
      headerSort: true,
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 150,
      // minWidth: 50,
    },
    {
      title: "General Use",
      field: "GeneralUse",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 150,
      // minWidth: 50,
    },
    {
      title: "State",
      field: "State",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 150,
      // minWidth: 50,
    },
    {
      title: "ESN",
      field: "esn",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 150,
      // minWidth: 50,
    },
    {
      title: "County ID",
      field: "CountyID",
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 150,
      // minWidth: 50,
    },
    {
      title: "Last Modified",
      field: "last_modified",
      mutator: translateToLocalDate,
      headerFilter: "input",
      headerFilterLiveFilter: false,
      width: 175,
    },
  ];

  return msagColumns;
}
